
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
       <div class="bg-white page-border">

        <div class="row row-replace add-m-b">
            <div class="col-9 col-p h5"><i class="fa fa fa-cogs"></i> Speak Up</div>
            <div class="col-3 top-corner-items col-p">
               <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard']"><i class="fa fa-arrow-left"></i> Back</button>
            </div>
         </div>
     
            <div class="row">
                <div class="col-md-4">
                    <span style="font-size: 26px; padding-top:20px;">
                        You Are requested to call on 
                        <b>0008000501464</b>
                    </span>
                </div>
            
            <div class="col-md-8">
                <img src="assets/img/speakUp.jpg" alt="Speak Up" class="img-fluid rounded">
            </div>
         </div>

        <!--end contant-->    
      </div>
    </div>
</div>   